import { render } from "./IconPlay.vue?vue&type=template&id=dee5d300"
import script from "./IconPlay.vue?vue&type=script&lang=js"
export * from "./IconPlay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__